import { $ } from '../vendors/jquery';

class Tabs
{
    constructor( element ) 
    {
        this.element = element;
        this.buttonsHolder = this.element.find( '[data-element="tabs-buttons-holder"]' );
        this.buttons       = this.element.find( '[data-element="tabs-button"]' );
        this.panelsHolder  = this.element.find( '[data-element="tabs-panels-holder"]' );
        this.panels        = this.element.find( '[data-element="tabs-panel"]' );

        this.init();
    }

    init() 
    {
        this.setFirstTabActive();
        this.buttons.each( ( index, element ) => {
            $( element ).on( 'click', this.onButtonClick.bind( this, element ) );
        } );
    }

    onButtonClick( button ) 
    {
        const tab = this.getTab( button );
        this.setAllTabsInactive( button );
        this.setTabActive( tab );
    }

    getTab( element ) 
    {
        const button = $( element );
        const index = button.data( 'tab-index' );
        const panel = this.panelsHolder.find( '[data-element="tabs-panel"][data-tab-index="' + index + '"]' );

        return { button, panel };
    }

    setFirstTabActive() 
    {
        const activeTab = this.element.find( '.is-active[data-element="tabs-button"]' );
        
        if ( activeTab.length > 0 ) {
            return;
        }

        const tab = this.getTab( this.buttons[0] );
        this.setTabActive( tab );
    }

    setTabActive( tab ) 
    {
        tab.button.addClass( 'is-active' );
        tab.button.attr( 'aria-selected', true );
        tab.panel.removeClass( 'd-none' );
    }

    setTabInactive( tab ) 
    {
        tab.button.removeClass( 'is-active' );
        tab.button.attr( 'aria-selected', false );
        tab.panel.addClass( 'd-none' );
    }

    setAllTabsInactive( button ) 
    {
        $( button ).closest( '[data-element="tabs-buttons-holder"]' ).find( '[data-element="tabs-button"]' ).each( ( index, element ) => {
            const tab = this.getTab( element );
            this.setTabInactive( tab );
        } );
    }
}

const tabs = {
    init() {
        const tabsElements = $( '[data-module="tabs"]' );

        if ( null !== tabsElements && tabsElements.length > 0 ) {
            tabsElements.each( ( index, element ) => {
                new Tabs( $( element ) );
            } );
        }
    }
};

export default tabs;
